// extracted by mini-css-extract-plugin
module.exports = {"Comparision":"Comparision_Comparision__37ckm"};